import { render } from "./About.vue?vue&type=template&id=4ebd2c52&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=4ebd2c52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ebd2c52"

export default script